import React from "react";

const CHUNK_RELOAD_FLAG = "uavsimnet_chunk_reload_attempted";

function isChunkLoadError(err) {
  if (!err) return false;
  return (
    err.name === "ChunkLoadError" ||
    /Loading chunk \d+ failed/i.test(err.message || "") ||
    /Loading CSS chunk \d+ failed/i.test(err.message || "")
  );
}

class ChunkLoadErrorBoundary extends React.Component {
  state = { showManualRefresh: false };

  static getDerivedStateFromError(err) {
    if (isChunkLoadError(err)) {
      const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_FLAG) === "1";
      if (alreadyReloaded) return { showManualRefresh: true };
      sessionStorage.setItem(CHUNK_RELOAD_FLAG, "1");
      setTimeout(() => window.location.reload(), 50);
      return { showManualRefresh: false };
    }
    throw err;
  }

  componentDidMount() {
    setTimeout(() => sessionStorage.removeItem(CHUNK_RELOAD_FLAG), 30000);
  }

  render() {
    if (this.state.showManualRefresh) {
      return (
        <div style={{ padding: 32, textAlign: "center", fontFamily: "system-ui" }}>
          <h2 style={{ color: "#0B2545" }}>Application updated</h2>
          <p style={{ color: "#5A6B7C" }}>
            Please refresh your browser to load the latest version
            (Ctrl+Shift+R on Windows / Cmd+Shift+R on Mac).
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChunkLoadErrorBoundary;
